<ng-container *transloco="let t">
  <div class="flex flex-col gap-3">
    @if (props.label) {
      <p class="font-semibold">
        {{ props.label }}
        <span class="text-red-500" *ngIf="props.required">*</span>
      </p>
    }

    @if (props.description) {
      <div>
        {{ props.description }}
      </div>
    }

    <!-- Multi-language mode -->
    @if (translatable) {
      <div class="flex flex-col gap-5 w-full pl-6 relative" [formGroup]="langFormGroup!">
        <!-- Vertical line decoration -->
        <div class="absolute left-0 top-0 w-0.5 bg-surface-200 dark:bg-surface-700 h-full"></div>

        @for (lang of languages; track $index) {
          <div class="flex flex-col gap-1 w-full relative">
            <p class="text-sm text-surface-600 dark:text-surface-400">
              <!-- t(app.formly-types.translatable.enLegend) -->
              <!-- t(app.formly-types.translatable.fiLegend) -->
              <!-- t(app.formly-types.translatable.svLegend) -->
              <!-- t(app.formly-types.translatable.noLegend) -->
              {{ t("app.formly-types.translatable." + lang + "Legend") }}
            </p>
            <p-editor
              [formControlName]="lang"
              [style]="{ height: '200px' }"
              (onBlur)="onBlur(lang)"
              [disabled]="formControl.disabled"
              [modules]="editorModules"
              [ngClass]="{
                'invalid-editor': isFieldInvalid(lang),
                'p-disabled': formControl.disabled,
              }"
            >
              <ng-template #header>
                <span class="ql-formats">
                  <select class="ql-size" [attr.aria-label]="t('app.transactionDetails.messageEditor.sizeButton')">
                    <option value="small">{{ t("app.transactionDetails.messageEditor.sizeSmall") }}</option>
                    <option selected>{{ t("app.transactionDetails.messageEditor.sizeNormal") }}</option>
                    <option value="large">{{ t("app.transactionDetails.messageEditor.sizeLarge") }}</option>
                    <option value="huge">{{ t("app.transactionDetails.messageEditor.sizeHuge") }}</option>
                  </select>
                  <button
                    type="button"
                    class="ql-bold"
                    [attr.aria-label]="t('app.transactionDetails.messageEditor.boldButton')"
                  ></button>
                  <button
                    type="button"
                    class="ql-italic"
                    [attr.aria-label]="t('app.transactionDetails.messageEditor.italicButton')"
                  ></button>
                  <button
                    type="button"
                    class="ql-underline"
                    [attr.aria-label]="t('app.transactionDetails.messageEditor.underlineButton')"
                  ></button>
                  <button
                    type="button"
                    class="ql-link"
                    [attr.aria-label]="t('app.transactionDetails.messageEditor.linkButton')"
                  ></button>
                  <button
                    type="button"
                    class="ql-list"
                    value="ordered"
                    [attr.aria-label]="t('app.transactionDetails.messageEditor.orderedListButton')"
                  ></button>
                </span>
              </ng-template>
            </p-editor>
            @if (isFieldInvalid(lang)) {
              <small class="text-red-500">
                <!-- t(app.formly-types.translatable.enTextRequired) -->
                <!-- t(app.formly-types.translatable.fiTextRequired) -->
                <!-- t(app.formly-types.translatable.svTextRequired) -->
                <!-- t(app.formly-types.translatable.noTextRequired) -->
                {{ t("app.formly-types.translatable." + lang + "TextRequired") }}
              </small>
            }
          </div>
        }
      </div>
    }

    <!-- Single-language mode -->
    @else {
      <div class="flex flex-col gap-1 w-full">
        <p-editor
          [formControl]="singleFormControl"
          [style]="{ height: '200px' }"
          (onBlur)="onBlur('single')"
          [disabled]="formControl.disabled"
          [modules]="editorModules"
          [ngClass]="{
            'invalid-editor': isSingleFieldInvalid(),
            'p-disabled': formControl.disabled,
          }"
        >
          <ng-template #header>
            <span class="ql-formats">
              <select class="ql-size" [attr.aria-label]="t('app.transactionDetails.messageEditor.sizeButton')">
                <option value="small">{{ t("app.transactionDetails.messageEditor.sizeSmall") }}</option>
                <option selected>{{ t("app.transactionDetails.messageEditor.sizeNormal") }}</option>
                <option value="large">{{ t("app.transactionDetails.messageEditor.sizeLarge") }}</option>
                <option value="huge">{{ t("app.transactionDetails.messageEditor.sizeHuge") }}</option>
              </select>
              <button
                type="button"
                class="ql-bold"
                [attr.aria-label]="t('app.transactionDetails.messageEditor.boldButton')"
              ></button>
              <button
                type="button"
                class="ql-italic"
                [attr.aria-label]="t('app.transactionDetails.messageEditor.italicButton')"
              ></button>
              <button
                type="button"
                class="ql-underline"
                [attr.aria-label]="t('app.transactionDetails.messageEditor.underlineButton')"
              ></button>
              <button
                type="button"
                class="ql-link"
                [attr.aria-label]="t('app.transactionDetails.messageEditor.linkButton')"
              ></button>
              <button
                type="button"
                class="ql-list"
                value="ordered"
                [attr.aria-label]="t('app.transactionDetails.messageEditor.orderedListButton')"
              ></button>
            </span>
          </ng-template>
        </p-editor>
        @if (isSingleFieldInvalid()) {
          <small class="text-red-500">{{ t("app.formly-types.validationMessages.textRequired") }}</small>
        }
      </div>
    }
  </div>
</ng-container>
